(() => {
  document.querySelectorAll('[data-kit-reviews]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const dialog = root.querySelector('dialog');
    const trigger = root.querySelector('[data-kit-write-review]');
    trigger.addEventListener('click', () => dialog.showModal());
    dialog.addEventListener('close', () => trigger.focus());
    root.querySelector('[data-kit-open-appio]').addEventListener('click', () => {
      const productId = root.querySelector('select').value;
      const status = root.querySelector('[data-kit-review-status]');
      const appio = window.Appio;
      if (!productId || !appio?.config || !appio.container || typeof appio.showWriteReviewForm !== 'function') {
        status.textContent = document.documentElement.lang.startsWith('es')
          ? 'El formulario se está cargando. Vuelve a intentarlo en unos segundos.'
          : 'The review form is loading. Please try again in a moment.';
        return;
      }
      // Appio submissions require a real Shopify product ID, never a collection ID.
      appio.data = { ...appio.data, productId };
      status.textContent = '';
      dialog.close();
      appio.showWriteReviewForm(true);
    });
  });
})();
